
import { ref, defineComponent, computed, watch } from "vue";
import store from "@/stores";
import router, { routeNames } from "@/router";
import {
  ErrorMessageFilter,
  IErrorResponse,
  isErrors,
} from "@/services/Models";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { AxiosResponse } from "axios";
import { consts } from "../services/Models";

export default defineComponent({
  name: "LoginForm",
  components: {
    ErrorMessage,
  },
  setup() {
    const login = store.useLoginStore();
    const auth = store.useAuthStore();
    const errors = ref<IErrorResponse[]>([]);
    const email = ref("");
    const resetEmail = ref("");
    const password = ref("");
    const isResetMode = ref(false);
    const isLoginFailure = ref(false);
    const errorMessages = computed(() => ({
      ResetEmail: ErrorMessageFilter(errors.value, "Mail"),
      LoginError: isLoginFailure.value ? [consts.loginFailure] : [],
    }));
    const preReset = () => {
      isResetMode.value = true;
    };
    const reset = async () => {
      // パスワードリセット
      await login
        .reset(resetEmail.value)
        .then(() => {
          isLoginFailure.value = false;
          isResetMode.value = false;
        })
        .catch((ex: AxiosResponse) => {
          if (isErrors(ex.data)) {
            errors.value = ex.data as IErrorResponse[];
          } else {
            alert(consts.resetPasswordFailure);
          }
        });
    };

    watch(
      () => isResetMode.value,
      (newVal) => {
        if (!newVal) {
          errors.value = [];
          resetEmail.value = "";
        }
      }
    );

    const signin = async () => {
      isLoginFailure.value = !(await login.signin(email.value, password.value));
      if (auth.state.isLoggedin) {
        router.push({ name: routeNames.Top });
      }
    };

    // エンターボタンを押下した際の動作
    const enterAction = async () => {
      if (isResetMode.value) {
        if (resetEmail.value !== "") {
          // リセットモードならパスワードリセット
          await reset();
        }
      } else {
        // ログインモードならログイン
        signin();
      }
    };

    return {
      ...login,
      ...auth,
      email,
      resetEmail,
      password,
      isResetMode,
      preReset,
      reset,
      signin,
      isLoginFailure,
      errorMessages,
      enterAction,
    };
  },
});
